import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getTenantDetails = (tenantName) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.LOGIN.GET_TENANT_DETAILS(tenantName)
  );
};

export default getTenantDetails;
